var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Select, Store } from '@ngxs/store';
import { DriveState } from '../state/drive-state';
import { Observable } from 'rxjs';
import { ToggleDetailsSidebar } from '../state/actions/commands';
var DetailsSidebarComponent = /** @class */ (function () {
    function DetailsSidebarComponent(store) {
        this.store = store;
    }
    DetailsSidebarComponent.prototype.close = function () {
        this.store.dispatch(new ToggleDetailsSidebar());
    };
    __decorate([
        Select(DriveState.selectedEntryOrActiveFolder),
        __metadata("design:type", Observable)
    ], DetailsSidebarComponent.prototype, "entry$", void 0);
    __decorate([
        Select(DriveState.activePage),
        __metadata("design:type", Observable)
    ], DetailsSidebarComponent.prototype, "activePage$", void 0);
    return DetailsSidebarComponent;
}());
export { DetailsSidebarComponent };
